import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from '../AuthContext';
import Swal from "sweetalert2";
import "./AdminAddProduct.css";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function AdminAddProduct() {
  const { authFetch } = useContext(AuthContext);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [price, setPrice] = useState("");
  const [uom, setUom] = useState("");
  const [category, setCategory] = useState("");
  const [categories, setCategories] = useState([]);
  const [stockQuantity, setStockQuantity] = useState("");
  //const [batchStockQuantity, setBatchStockQuantity] = useState("");
  //const [stockQuantityModified, setStockQuantityModified] = useState(false);
  //const [batchStockQuantityModified, setBatchStockQuantityModified] = useState(false);
  const [moq, setMoq] = useState("");
  const [isIncreaseByMOQ, setIsIncreaseByMOQ] = useState(false);
  const [productCode, setProductCode] = useState("");
  const navigate = useNavigate();

  const [mainImageFile, setMainImageFile] = useState(null);
  const [mainImagePreview, setMainImagePreview] = useState(null);
  const [additionalImages, setAdditionalImages] = useState([]);
  const MAX_ADDITIONAL_IMAGES = 4;

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/products/categories`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch categories");
        }
        const data = await response.json();
        const filteredCategories = data.filter(category => !category.hasSubcategories);
        setCategories(filteredCategories);
      } catch (error) {
        // Silent fail (previously only 1 console.error line in this catch block, no other actions)
      }
    };
    fetchCategories();
  }, []);

  const validateStockQuantities = () => {
    if (stockQuantity && parseInt(stockQuantity) < 0) {
      Swal.fire({
        icon: 'error',
        title: 'Invalid Stock Quantity',
        text: 'Stock quantity cannot be negative.',
        confirmButtonColor: '#e74c3c'
      });
      return false;
    }

    // if (batchStockQuantity && parseInt(batchStockQuantity) < 0) {
    //   Swal.fire({
    //     icon: 'error',
    //     title: 'Invalid Batch Stock Quantity',
    //     text: 'Batch stock quantity cannot be negative.',
    //     confirmButtonColor: '#e74c3c'
    //   });
    //   return false;
    // }

    // if (stockQuantity && batchStockQuantity &&
    //   parseInt(stockQuantity) > parseInt(batchStockQuantity)) {
    //   Swal.fire({
    //     icon: 'error',
    //     title: 'Invalid Stock Quantity',
    //     text: 'Current stock quantity cannot exceed batch stock quantity.',
    //     confirmButtonColor: '#e74c3c'
    //   });
    //   return false;
    // }

    // if (stockQuantity && parseInt(stockQuantity) > 0 &&
    //   (!batchStockQuantity || parseInt(batchStockQuantity) <= 0)) {
    //   Swal.fire({
    //     icon: 'error',
    //     title: 'Invalid Batch Stock Quantity',
    //     text: 'Batch stock quantity must be set if stock quantity is set.',
    //     confirmButtonColor: '#e74c3c'
    //   });
    //   return false;
    // }

    // MOQ is optional. Only validate it when a value was entered.
    if (moq !== "" && moq !== null && moq !== undefined && parseInt(moq) < 1) {
      Swal.fire({
        icon: 'error',
        title: 'Invalid MOQ',
        text: 'MOQ must be more than 0.',
        confirmButtonColor: '#e74c3c'
      });
      return false;
    }

    return true;
  };

  const handleStockQuantityChange = (e) => {
    const value = e.target.value;
    setStockQuantity(value);
    //setStockQuantityModified(true);

    // setTimeout(() => {
    //   const element = document.getElementById('stockQuantity');
    //   if (value && batchStockQuantity && parseInt(value) > parseInt(batchStockQuantity)) {
    //     element?.classList.add('admin-edit-product-input-warning');
    //   } else {
    //     element?.classList.remove('admin-edit-product-input-warning');
    //   }
    // }, 0);
  };

  // const handleBatchStockQuantityChange = (e) => {
  //   const value = e.target.value;
  //   setBatchStockQuantity(value);
  //   setBatchStockQuantityModified(true);

  //   setTimeout(() => {
  //     const stockField = document.getElementById('stockQuantity');
  //     if (stockQuantity && value && parseInt(stockQuantity) > parseInt(value)) {
  //       stockField?.classList.add('admin-edit-product-input-warning');
  //     } else {
  //       stockField?.classList.remove('admin-edit-product-input-warning');
  //     }
  //   }, 0);
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!mainImageFile) {
      Swal.fire({
        icon: 'warning',
        title: 'Main Image Required',
        text: 'Please upload a main image for the product.',
        confirmButtonColor: '#45a049'
      });
      return;
    }

    if (!validateStockQuantities()) {
      return;
    }

    if (price && parseFloat(price) <= 0) {
      Swal.fire({
        icon: 'error',
        title: 'Invalid Price',
        text: 'Price must be greater than zero.',
        confirmButtonColor: '#e74c3c'
      });
      return;
    }

    // UOM is optional - no validation needed.

    try {
      Swal.fire({
        title: 'Adding Product',
        text: 'Please wait while we add your product...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const formData = new FormData();
      formData.append("Name", name);
      formData.append("Description", description);
      formData.append("Price", price);
      formData.append("CategoryID", category);
      formData.append("StockQuantity", stockQuantity);
      //formData.append("BatchStockQuantity", batchStockQuantity);
      formData.append("MOQ", moq ?? "");
      formData.append("UOM", uom ?? "");
      formData.append("ProductCode", productCode);
      formData.append("IsRedeemable", false);
      formData.append("IsIncreaseByMOQ", isIncreaseByMOQ);

      if (mainImageFile) {
        formData.append("ImageFile", mainImageFile);
      }
      additionalImages.forEach((img, index) => {
        formData.append(`AdditionalImageFiles`, img.file);
      });

      const response = await authFetch(`${API_BASE_URL}/products`, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Failed to add product");
      }
      const newProduct = await response.json();
      Swal.fire({
        title: 'Success!',
        text: 'Product added successfully!',
        icon: 'success',
        timer: 1500,
        confirmButtonColor: '#45a049'
      }).then(() => {
        navigate(`/admin/edit-product/${newProduct.productID}`);
      });
    } catch (error) {
      Swal.fire({
        title: 'Error!',
        text: 'Failed to add product: ' + error.message,
        icon: 'error',
        confirmButtonColor: '#d33'
      });
    }
  };

  const handleMainImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      if (file.size > 5 * 1024 * 1024) {
        Swal.fire({
          icon: 'error',
          title: 'File Too Large',
          text: 'Please select an image under 5MB.',
          confirmButtonColor: '#e74c3c'
        });
        return;
      }
      const extension = file.name.split('.').pop().toLowerCase();
      const allowedExtensions = ['jpg', 'jpeg', 'png'];
      if (!allowedExtensions.includes(extension)) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid File Type',
          text: 'Please select a valid image file (JPG, JPEG, PNG only).',
          confirmButtonColor: '#e74c3c'
        });
        return;
      }

      setMainImageFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setMainImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleClearMainImage = () => {
    Swal.fire({
      title: 'Remove Main Image?',
      text: 'Are you sure you want to remove this image?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#e74c3c',
      cancelButtonColor: '#7a7a7a',
      confirmButtonText: 'Yes'
    }).then((result) => {
      if (result.isConfirmed) {
        setMainImageFile(null);
        setMainImagePreview(null);
      }
    });
  };

  const handleAdditionalImageChange = (e) => {
    const files = Array.from(e.target.files);

    if (files.length === 0) return;

    // Check if adding these files would exceed the limit
    if (additionalImages.length + files.length > MAX_ADDITIONAL_IMAGES) {
      Swal.fire({
        icon: 'warning',
        title: 'Too Many Images',
        text: `You can upload a maximum of ${MAX_ADDITIONAL_IMAGES} additional images.`,
        confirmButtonColor: '#e74c3c'
      });
      return;
    }

    for (const file of files) {
      if (file.size > 5 * 1024 * 1024) {
        Swal.fire({
          icon: 'error',
          title: 'File Too Large',
          text: 'Please select images under 5MB.',
          confirmButtonColor: '#e74c3c'
        });
        return;
      }

      const extension = file.name.split('.').pop().toLowerCase();
      const allowedExtensions = ['jpg', 'jpeg', 'png'];
      if (!allowedExtensions.includes(extension)) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid File Type',
          text: 'Please select valid image files (JPG, JPEG, PNG only).',
          confirmButtonColor: '#e74c3c'
        });
        return;
      }
    }

    const newImages = [];

    files.forEach(file => {
      const reader = new FileReader();
      reader.onloadend = () => {
        newImages.push({
          file,
          preview: reader.result,
          displayOrder: additionalImages.length + newImages.length
        });

        // If all files have been processed, update state
        if (newImages.length === files.length) {
          setAdditionalImages([...additionalImages, ...newImages]);
        }
      };
      reader.readAsDataURL(file);
    });
  };

  const handleRemoveAdditionalImage = (index) => {
    Swal.fire({
      title: 'Remove Image?',
      text: 'Are you sure you want to remove this image?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#e74c3c',
      cancelButtonColor: '#7a7a7a',
      confirmButtonText: 'Yes'
    }).then((result) => {
      if (result.isConfirmed) {
        // Remove the image at the specified index
        const newImages = [...additionalImages];
        newImages.splice(index, 1);

        // Reorder the remaining images
        newImages.forEach((img, i) => {
          img.displayOrder = i;
        });

        setAdditionalImages(newImages);
      }
    });
  };

  const moveAdditionalImage = (index, direction) => {
    if ((direction === 'up' && index === 0) ||
      (direction === 'down' && index === additionalImages.length - 1)) {
      return;
    }

    const newImages = [...additionalImages];
    const targetIndex = direction === 'up' ? index - 1 : index + 1;

    // Swap the items
    [newImages[index], newImages[targetIndex]] = [newImages[targetIndex], newImages[index]];

    // Update display order
    newImages.forEach((img, i) => {
      img.displayOrder = i;
    });

    setAdditionalImages(newImages);
  };


  return (
    <div className="admin-add-product-container">
      <div className="admin-add-product-header">
        <button
          className="admin-add-product-back-btn"
          onClick={() => navigate("/admin/products")}
        >
          <i className="fas fa-arrow-left"></i> Back to Products
        </button>
      </div>

      <div className="admin-add-product-title">
        <h1>Add New Product</h1>
      </div>
      <form
        onSubmit={handleSubmit}
        className="admin-add-product-details-form"
      >
        <div className="admin-add-product-form-group">
          <label>Name:</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Product name"
            required
          />
        </div>
        <div className="admin-add-product-form-group">
          <label>Category:</label>
          <select
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            required
          >
            <option value="">Select a category</option>
            {categories.map((cat) => (
              <option key={cat.categoryID} value={cat.categoryID}>
                {cat.name}
              </option>
            ))}
          </select>
        </div>
        <div className="admin-add-product-form-group">
          <label>Product Code:</label>
          <input
            type="text"
            value={productCode}
            onChange={(e) => setProductCode(e.target.value)}
            placeholder="Product code"
            required
          />
        </div>
        <div className="admin-add-product-form-group">
          <label>Product UOM:</label>
          <input
            type="text"
            value={uom}
            onChange={(e) => setUom(e.target.value)}
            placeholder="Product UOM (optional)"
          />
        </div>

        <div className="admin-add-product-form-group">
          <label>Description:</label>
          <textarea
            type="text"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Product description"
            required
          />
        </div>

        {/* <div className="admin-add-product-form-group">
          <label>Batch Stock Quantity:</label>
          <input
            id="batchStockQuantity"
            type="number"
            value={batchStockQuantity}
            onChange={handleBatchStockQuantityChange}
            placeholder="Batch stock quantity (optional for pre-order)"
          />
          <small className="admin-edit-product-help-text">
            Stock quantity of one batch. Current stock will be set to this value by default.
          </small>
        </div> */}
        <div className="admin-add-product-form-group">
          <label>Current Stock Quantity:</label>
          <input
            id="stockQuantity"
            type="number"
            value={stockQuantity}
            onChange={handleStockQuantityChange}
            placeholder="Current stock quantity (optional for pre-order)"
          />
          {/* {stockQuantity && batchStockQuantity && parseInt(stockQuantity) > parseInt(batchStockQuantity) && (
            <small className="admin-edit-product-warning-text">
              Warning: Stock quantity exceeds batch stock quantity
            </small>
          )} */}
        </div>
        <div className="admin-add-product-form-group">
          <label>Price:</label>
          <input
            type="number"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            placeholder="Price (optional for pre-order)"
          />
        </div>
        <div className="admin-add-product-form-group">
          <label>MOQ:</label>
          <input
            type="number"
            value={moq}
            onChange={(e) => setMoq(e.target.value)}
            placeholder="Minimum order quantity (optional)"
          />
        </div>
        <div className="admin-add-product-form-group" style={{ textAlign: 'left' }}>
          <label style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' ,whiteSpace: 'nowrap'}}>Increase By MOQ: <input
            type="checkbox"
            value={isIncreaseByMOQ}
            checked={isIncreaseByMOQ}
            onChange={(e) => setIsIncreaseByMOQ(e.target.checked)}
          /></label> 
        </div>

        {/* Product Images Section */}
        <div className="admin-add-product-form-group">
          <label>Product Images:</label>
          <div className="admin-add-product-images-row">
            {/* Main Image Section */}
            <div className="admin-add-product-main-image-section">
              <div className="admin-add-product-main-image-label">Main Image</div>
              <div className="admin-add-product-image-item">
                <label htmlFor="productMainImageUpload">
                  {mainImagePreview ? (
                    <div className="admin-add-product-image-card">
                      <img src={mainImagePreview} alt="Main Product Preview" />
                      <div className="admin-add-product-image-order-badge">1</div>
                    </div>
                  ) : (
                    <div className="admin-add-product-image-card">
                      <div className="admin-add-product-upload-placeholder">
                        <i className="fas fa-cloud-upload-alt"></i>
                        <div className="admin-add-product-upload-text">
                          <span>Main Image</span>
                          <span className="admin-add-product-upload-subtext">Max 5MB</span>
                        </div>
                      </div>
                    </div>
                  )}
                  <input
                    id="productMainImageUpload"
                    type="file"
                    accept="image/*"
                    onChange={handleMainImageChange}
                    style={{ display: 'none' }}
                  />
                </label>
                {mainImagePreview && (
                  <div className="admin-add-product-image-actions-visible">
                    <button
                      type="button"
                      className="admin-add-product-delete"
                      onClick={handleClearMainImage}
                      title="Remove image"
                    >
                      <i className="fas fa-trash"></i>
                    </button>
                  </div>
                )}
              </div>
            </div>

            {/* Divider */}
            <div className="admin-add-product-image-divider"></div>

            {/* Additional Images Section */}
            <div className="admin-add-product-additional-images-section">
              <div className="admin-add-product-additional-images-label">Additional Images (up to {MAX_ADDITIONAL_IMAGES})</div>
              <div className="admin-add-product-additional-images-container">
                {/* Display additional images */}
                {additionalImages.map((img, index) => (
                  <div key={index} className="admin-add-product-image-item">
                    <div className="admin-add-product-image-card">
                      <img src={img.preview} alt={`Additional ${index + 1}`} />
                      <div className="admin-add-product-image-order-badge">{index + 2}</div>
                    </div>
                    <div className="admin-add-product-image-actions-visible">
                      <button
                        type="button"
                        className="admin-add-product-edit"
                        onClick={() => moveAdditionalImage(index, 'up')}
                        disabled={index === 0}
                        title="Move up"
                      >
                        <i className="fas fa-arrow-up"></i>
                      </button>
                      <button
                        type="button"
                        className="admin-add-product-edit"
                        onClick={() => moveAdditionalImage(index, 'down')}
                        disabled={index === additionalImages.length - 1}
                        title="Move down"
                      >
                        <i className="fas fa-arrow-down"></i>
                      </button>
                      <button
                        type="button"
                        className="admin-add-product-delete"
                        onClick={() => handleRemoveAdditionalImage(index)}
                        title="Remove image"
                      >
                        <i className="fas fa-trash"></i>
                      </button>
                    </div>
                  </div>
                ))}

                {/* Upload additional image button */}
                {additionalImages.length < MAX_ADDITIONAL_IMAGES && (
                  <div className="admin-add-product-image-item">
                    <label htmlFor="additionalImageUpload">
                      <div className="admin-add-product-image-card">
                        <div className="admin-add-product-upload-placeholder">
                          <i className="fas fa-plus"></i>
                          <div className="admin-add-product-upload-text">
                            <span>Add Image</span>
                            <span className="admin-add-product-upload-subtext">Max 5MB</span>
                          </div>
                        </div>
                      </div>
                    </label>
                    <input
                      id="additionalImageUpload"
                      type="file"
                      accept="image/*"
                      multiple
                      onChange={handleAdditionalImageChange}
                      style={{ display: 'none' }}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <button type="submit" className="admin-add-product-btn-primary" disabled={!name.trim()}>
          <i className="fas fa-save"></i> Add Product
        </button>
      </form>
    </div>
  );
}

export default AdminAddProduct;